import { render, staticRenderFns } from "./prompt-popup.vue?vue&type=template&id=277edd82&scoped=true"
import script from "./prompt-popup.vue?vue&type=script&lang=js"
export * from "./prompt-popup.vue?vue&type=script&lang=js"
import style0 from "./prompt-popup.vue?vue&type=style&index=0&id=277edd82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277edd82",
  null
  
)

export default component.exports